export const enum RegisterCodeEnum {
    AdminEnhet = 'soa',
    Arkiver = 'nar',
    Arkivdeler = 'nad',
    Behandlingstype = 'sbt',
    Brukere = 'sbr',
    Brukerroller = 'gbr',
    Gruppe = 'ggr',
    GruppeMedlemskap = 'ggi',
    Informasjonstyper = 'nit',
    Journalenheter = 'nje',
    Tilgangsgrupper = 'ntg',
    TilgangsgruppeMedlemskap = 'npg',
    FellesEpostboks = 'feb',
    Identiteter = 'gid',
    LoggingMapping = 'glm',
    IdentitetRelasjoner = 'gre',
    IdentitetAdresser = 'gia',
    Tilleggsdata = 'vsd',
    Dataverdi = 'vdv',
    TagEgenskap = 'tae',
    Tag = 'tag',
    TilleggsdataKobling = 'vsk',
    Journalkategori = 'sal',
    KassBevVedtak = 'nkb',
    Ordningsverdier = 'nov',
    Miljo = 'gmi',
    MiljoVariabler = 'gvr',
    Rolle = 'gro',
    Funksjon = 'gfu',
    NodeMeny = 'gnm',
    NoderTilgang = 'gnt',
    Systemparameter = 'gsy',
    SysBruker = 'gsb',
    JFOrdnVer = 'njo',
    Kurv = 'gmn',
    LightKurv = 'lgmn',
    kodeHistorikk = 'skh',
    MenyValg = 'gmv',
    Database = 'd_dba',
    DbLokasjon = 'd_dbl',
    Forsendelsesmate = 'nfk',
    Sone = 'gso',
    Sakstype = 'ska',
    Partsforhold = 'spf',
    Fylke = 'GFY',
    Gla_Land = '',
    DBSJEKK = 'DBSJEKK',
    DB_SJEKK = 'DB_SJEKK',
    Tilgangskoder = 'SGR',
    SaksbehStatus = 'SBHS',
    Oppgaver = 'opp',
    IndekseringLogg = 'INDL',
    Tekstmal = 'GTM',
    MALSAKER = 'MALSAKER',
}

export const ValgRegister: { id: string, navn: string }[] = [
    {
        id: 'SOA',
        navn: 'Administrativ enhet',
    },
    // {
    //     id: 'GTM,',
    //     navn: 'Tekstmal',
    // },
    {
        id: 'NAR',
        navn: 'Arkiver',
    },
    {
        id: 'NAD',
        navn: 'Arkivdeler',
    },
    {
        id: 'SBT',
        navn: 'Behandlingstype',
    },
    {
        id: 'SBR',
        navn: 'Brukere',
    },
    {
        id: 'GBR',
        navn: 'Brukerroller',
    },
    {
        id: 'GGR',
        navn: 'Gruppe',
    },
   
    {
        id: 'GID',
        navn: 'Identiteter',
    },
    {
        id: 'NIT',
        navn: 'Informasjonstyper',
    },
    {
        id: 'NJE',
        navn: 'Journalenheter',
    },
    {
        id: 'SAL',
        navn: 'Journalkategori',
    },
    {
        id: 'GKO',
        navn: 'Kommune',
    },
    {
        id: 'GMN',
        navn: 'Kurv',
    },
    {
        id: 'MALSAKER',
        navn: 'Mal for arkivsaker',
    },
    {
        id: 'MALJOURNALPOST',
        navn: 'Mal for dokumenttyper',
    },
    {
        id: 'NOV',
        navn: 'Ordningsverdier',
    },
    {
        id: 'NOP',
        navn: 'Ordningsprinsipper',
    },
    {
        id: 'GPO',
        navn: 'Postnummer',
    },    
    
    {
        id: 'GRE',
        navn: 'Relasjoner',
    },
    {
        id: 'GRU',
        navn: 'RelasjonUnder',
    },
    {
        id: 'GSO',
        navn: 'Sone',
    },
    {
        id: 'GSY',
        navn: 'Systemparameter',
    },
  
    {
        id: 'NTG',
        navn: 'Tilgangsgrupper',
    },
    {
        id: 'NPG',
        navn: 'Tilgangsgruppe medlemskap',
    },
    {
        id: 'VSD',
        navn: 'Tilleggsdata',
    },
    // {
    //     id: 'INDL',
    //     navn: 'Søkeindeksering',
    // },

];


export type RegisterCodeName = 'GFY' | 'GGR' | 'GID' | 'GKA' | 'GKO' | 'GLA' | 'GPO' | 'POSTNROPPD' |
    'NAR' | 'NAD' | 'NAP' | 'NAS' | 'NAG' | 'TAK' | 'NBK' | 'NJE' | 'NKK' | 'NKB' | 'LOV' | 'NOT' | 'NOP' | 'NOV' | 'SPG' | 'SGR' | 'ÅRSSKIFTE' |
    'BAT' | 'GDT' | 'BFA' | 'BGT' | 'SBHS' | 'BST' | 'BTT' | 'ELI' | 'KKT' | 'TAG' | 'NDK' | 'NDS' | 'NDT' | 'NVF' | 'NLF' | 'GTM' | 'SAM' | 'SBT' |
    'SDT' | 'NFM' | 'SAL' | 'NJS' | 'GPI' | 'SOA' | 'SBR' | 'SET' | 'ORG' | 'ORT' | 'OVERFADMENH' | 'NTG' | 'SAG' | 'SJT' | 'SPF' | 'NSS' | 'SKA' |
    'DBA' | 'DBSJEKK' | 'GLO' | 'FEB' | 'GFU' | 'NIT' | 'GMN' | 'GMI' | 'PRT' | 'PTT' | 'GRM' | 'GSO' | 'GSP' | 'GSY' | 'SPR' | 'GTK' |
    'GTF' | 'GNM' | 'VSD' | 'VFS' | 'DFT' | 'VRF' | 'OPPGAVETYPER' | 'MALSAKER' | 'INDL'
    | 'MALJOURNALPOST';
